import * as DateUtils from "../../utils/date/date";

export class ReportSummary {
    constructor(props) {
        this.props = props;
    }

    getGeneratedDescription(clean = false) {
        const date = DateUtils.dateToString(this.props.createdAt, "dd/MM/yyyy");

        if (this.props.errorGenerate) return `Erro na hora de gerar: ${date}`;

        if (this.props.automaticPilot) return `Gerado Nanda: ${date}`;

        if (this.props.automaticGenerate) return `Gerado Automático: ${date}`;

        return clean
            ? `${this.props.createdBy}: ${date}`
            : `Gerado por ${this.props.createdBy}: ${date}`;
    }

    getReportLink({
        accountingId,
        companyId,
        download = false,
        token,
        userId
    }) {
        const types = {
            balance: `balanco/${this.props._id}`,

            balanceComparation: `balanco/${this.props._id}/comparacao`,

            dashboard: `dashboard/${this.props._id}`,

            dre: `dre/${this.props._id}`,

            dreComparation: `dre/${this.props._id}/comparacao`,

            monitoring: `regras/${this.props._id}`
        };

        let urlDownload = `${
            publicSettings.url
        }/contabilidade/${accountingId}/empresa/${companyId}/relatorios/${
            types[this.props.type] || ""
        }`;

        const baseUrl = publicSettings.url;
        let url = `${baseUrl}/relatorio/${companyId}/${accountingId}/${this.props.type}/${userId}/${this.props._id}?liveToken=${token}`;

        if (download) {
            urlDownload = `${urlDownload}?download=true`;

            return urlDownload;
        }

        return url;
    }

    getWppLink({ companyId, accountingId, userId, token, companyName } = {}) {
        const baseUrl = publicSettings.url;

        const uri = `${baseUrl}/relatorio/${companyId}/${accountingId}/${this.props.type}/${userId}/${this.props._id}?liveToken=${token}`;

        const whatsappAPI = "https://api.whatsapp.com/send?text=";

        const result = `${whatsappAPI} Olá, confira o Dash que preparei da ${encodeURIComponent(
            companyName
        )} Clique no link abaixo para visualizar:\n ${uri}`;

        return result;
    }

    get withInteraction() {
        return this._getLastInteraction();
    }

    get withVisualization() {
        if (
            !this.props.interaction?.visualization?.date ||
            this.props.interaction?.visualization?.total <= 0
        )
            return null;
        const dateFormated = DateUtils.dateToString(
            new Date(this.props.interaction?.visualization?.date),
            "dd/MM/yyyy"
        );
        return dateFormated;
    }

    _getLastInteraction() {
        if (!this.props?.interaction) return null;

        const interactions = Object.keys(this.props.interaction)
            .filter((i) => ["comments", "deslike", "like"].includes(i))
            .map((i) => this.props.interaction[i])
            .filter((i) => i.date);
        if (!interactions.length) return null;
        const sortedInteractions = interactions.sort((a, b) => {
            return new Date(b.date) - new Date(a.date);
        });
        const dateFormated = DateUtils.dateToString(
            new Date(sortedInteractions[0].date),
            "dd/MM/yyyy"
        );
        return dateFormated;
    }
}
